// extracted by mini-css-extract-plugin
export default {"card":"CardSellers_card__Ss-KK","header":"CardSellers_header__Cw6-7","photo":"CardSellers_photo__wirDW","name":"CardSellers_name__T7FVu","link":"CardSellers_link__iqqor"};